import useStores from './use-stores';
import MerchantConfiguration from '../stores/merchant-configurations/domain-objects/merchant-configuration';

const useMerchantConfiguration = (): MerchantConfiguration => {
	const { merchantConfigurationsStore } = useStores();

	return merchantConfigurationsStore.configuration;
};

export default useMerchantConfiguration;
